import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=8a69257c&scoped=true"
import script from "./Template2.vue?vue&type=script&lang=js"
export * from "./Template2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a69257c",
  null
  
)

export default component.exports